import * as React from 'react';
import { VariantProps, cva, cx } from 'class-variance-authority';

type OutlineProps = Omit<React.ComponentProps<'div'>, 'ref'> &
  VariantProps<typeof compClasses> & {
    className?: string;
  };

export const Outline = (props: OutlineProps) => {
  const { children, variantStyle, systemStyle, className, ...rest } = props;

  return (
    <div
      className={cx(compClasses({ variantStyle, systemStyle }), className)}
      {...rest}
    >
      {children}
    </div>
  );
};

const compClasses = cva(['flex', 'flex-col'], {
  variants: {
    variantStyle: {
      default: '',
      primary: '',
      secondary: '',
      tertiary: '',
    },
    systemStyle: {
      success: '',
      warning: '',
      danger: '',
    },
  },
  compoundVariants: [
    {
      variantStyle: 'default',
      className:
        'border-borderLight-default dark:border-borderDark-default border',
    },
    {
      variantStyle: 'primary',
      className:
        'border-borderLight-primary dark:border-borderDark-primary border',
    },
    {
      variantStyle: 'secondary',
      className:
        'border-borderLight-secondary dark:border-borderDark-secondary border',
    },
    {
      variantStyle: 'tertiary',
      className:
        'border-borderLight-tertiary dark:border-borderDark-tertiary border',
    },
    {
      systemStyle: 'success',
      className: 'border-success hover:shadow-success border',
    },
    {
      systemStyle: 'warning',
      className: 'border-yellow hover:shadow-warning border',
    },
    {
      systemStyle: 'danger',
      className: 'border-error hover:shadow-error border',
    },
  ],
});
